import { getYearDifference } from "./getYearDifference";
import { sinkingFundPayment } from "./sinkingFundPayment";

type Params = {
	years: number;
	targetAmount: number;
	interestRate: number;
};

export const getSavingsPlan = ({
	years,
	targetAmount,
	interestRate,
}: Params) => {
	const monthlyInterest = interestRate / 12 / 100;
	const yearDifference = getYearDifference(years);

	return {
		monthlyPayment: sinkingFundPayment(
			monthlyInterest,
			years * 12,
			targetAmount,
		),
		yearDifference,
		monthlyPaymentLater: sinkingFundPayment(
			monthlyInterest,
			(years - yearDifference) * 12,
			targetAmount,
		),
	};
};
